module.exports = new __parcel__URL__("scratch02.ceb90ed7.png").toString();